<template>
    <div style="height: 100vh">
        <empty-box v-if="timeout" text="页面过期啦~"/>
    </div>
</template>

<script>
export default {
    name: "index",
    data() {
        return {
            timeout: false
        }
    },
    mounted() {
        const token = this.$route.params.token
        this.timeout = token === 'empty'
        if (!this.timeout) {
            sessionStorage.setItem('payment_token', token)
            this.$router.push('/payment/reports')
        }
    }
}
</script>

<style lang="less" scoped>

</style>
